import React from 'react';
import {
  FaExclamationTriangle,
  FaInfoCircle,
  FaCheckCircle,
  FaTimesCircle,
} from 'react-icons/fa';

const configTipo = {
  warning: {
    icono: FaExclamationTriangle,
    bgColor: 'bg-amber-50',
    borderColor: 'border-amber-200',
    iconColor: 'text-amber-600',
  },
  danger: {
    icono: FaTimesCircle,
    bgColor: 'bg-red-50',
    borderColor: 'border-red-200',
    iconColor: 'text-red-600',
  },
  info: {
    icono: FaInfoCircle,
    bgColor: 'bg-blue-50',
    borderColor: 'border-blue-200',
    iconColor: 'text-blue-600',
  },
  success: {
    icono: FaCheckCircle,
    bgColor: 'bg-emerald-50',
    borderColor: 'border-emerald-200',
    iconColor: 'text-emerald-600',
  },
};

const SeccionAlertas = ({ alertas = [] }) => {
  return (
    <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-5 h-full flex flex-col">
      {/* Header */}
      <div className="flex items-center justify-between mb-4 flex-shrink-0">
        <h3 className="text-base font-semibold text-gray-800">Alertas</h3>
        <span className="text-xs text-gray-400 bg-gray-100 px-3 py-1 rounded-full">
          Secuencias NCF
        </span>
      </div>

      {/* Lista de alertas */}
      <div className="space-y-3 overflow-y-auto flex-1 pr-1">
        {alertas.length === 0 ? (
          <div className="flex flex-col items-center justify-center py-8 text-gray-400">
            <FaCheckCircle className="text-3xl text-emerald-400 mb-2" />
            <p className="text-sm font-medium text-gray-500">Sin alertas</p>
            <p className="text-xs text-gray-400 mt-1">Todas las secuencias están en orden</p>
          </div>
        ) : (
          alertas.map((alerta) => {
            const config = configTipo[alerta.tipo] || configTipo.info;
            const Icono = config.icono;

            return (
              <div
                key={alerta.id}
                className={`flex items-start gap-3 p-3 rounded-lg border ${config.bgColor} ${config.borderColor} transition-all hover:shadow-sm`}
              >
                <Icono className={`${config.iconColor} text-base flex-shrink-0 mt-0.5`} />
                <div className="flex-1 min-w-0">
                  <p className="text-sm text-gray-700 leading-snug">{alerta.mensaje}</p>
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default SeccionAlertas;
